import React from "react";

import {
  TaxW9AgreementContainer,
  DocumentSection,
  DocumentSectionTitle,
  DocumentSectionDescription,
  DocumentGrid,
  DocumentItem,
  DocumentLabel,
  DocumentIcon,
} from "./TaxW9Agreement.styles.js";

const DocumentIconSVG = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 1.7021V4.8C10.5 5.22004 10.5 5.43006 10.5817 5.59049C10.6537 5.73161 10.7684 5.84635 10.9095 5.91825C11.0699 6 11.28 6 11.7 6H14.7979M15 7.49117V12.9C15 14.1601 15 14.7902 14.7548 15.2715C14.539 15.6948 14.1948 16.039 13.7715 16.2548C13.2902 16.5 12.6601 16.5 11.4 16.5H6.6C5.33988 16.5 4.70982 16.5 4.22852 16.2548C3.80516 16.039 3.46095 15.6948 3.24524 15.2715C3 14.7902 3 14.1601 3 12.9V5.1C3 3.83988 3 3.20982 3.24524 2.72852C3.46095 2.30516 3.80516 1.96095 4.22852 1.74524C4.70982 1.5 5.33988 1.5 6.6 1.5H9.00883C9.55916 1.5 9.83432 1.5 10.0933 1.56217C10.3229 1.61729 10.5423 1.7082 10.7436 1.83156C10.9707 1.9707 11.1653 2.16527 11.5544 2.55442L13.9456 4.94558C14.3347 5.33473 14.5293 5.5293 14.6684 5.75636C14.7918 5.95767 14.8827 6.17715 14.9378 6.40673C15 6.66568 15 6.94084 15 7.49117Z"
      stroke="#535862"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const documents = [
  {
    id: "customer_agreement",
    title: "Customer Agreement.pdf",
    url: "https://internal-account-tax-docs.s3.us-east-1.amazonaws.com/quantbase_customer_agreement.pdf",
  },
  {
    id: "client_agreement",
    title: "Client Agreement.pdf",
    url: "https://internal-account-tax-docs.s3.us-east-1.amazonaws.com/quantbase_client_agreement.pdf",
  },
  {
    id: "form_crs",
    title: "Form CRS.pdf",
    url: "https://internal-account-tax-docs.s3.us-east-1.amazonaws.com/quantbase_form_crs.pdf",
  },
  {
    id: "form_adv_2a",
    title: "Form ADV Part 2A.pdf",
    url: "https://internal-account-tax-docs.s3.us-east-1.amazonaws.com/quantbase_form_adv_pt_2a.pdf",
  },
  {
    id: "form_adv_2b",
    title: "Form ADV Part 2B.pdf",
    url: "https://internal-account-tax-docs.s3.us-east-1.amazonaws.com/quantbase_form_adv_pt_2b.pdf",
  },
  {
    id: "ard_disclosure",
    title: "ARD Disclosure.pdf",
    url: "https://internal-account-tax-docs.s3.us-east-1.amazonaws.com/advisory_relationship_disclosure.pdf",
  },
];

const TaxW9Agreement = () => {
  const handleDocumentClick = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <TaxW9AgreementContainer>
      <DocumentSection>
        <DocumentSectionTitle>Tax certification</DocumentSectionTitle>
        <DocumentSectionDescription>
          Please review the documents listed below. You can click on any
          document to open it in a new tab.
        </DocumentSectionDescription>

        <DocumentGrid>
          {documents.map((doc) => (
            <DocumentItem
              key={doc.id}
              onClick={() => handleDocumentClick(doc.url)}
            >
              <DocumentIcon>
                <DocumentIconSVG />
              </DocumentIcon>
              <DocumentLabel>{doc.title}</DocumentLabel>
            </DocumentItem>
          ))}
        </DocumentGrid>
      </DocumentSection>
    </TaxW9AgreementContainer>
  );
};

export { TaxW9Agreement };
